import { render, staticRenderFns } from "./common-item.vue?vue&type=template&id=3b8c463e&scoped=true&"
import script from "./common-item.vue?vue&type=script&lang=js&"
export * from "./common-item.vue?vue&type=script&lang=js&"
import style0 from "./common-item.vue?vue&type=style&index=0&id=3b8c463e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b8c463e",
  null
  
)

export default component.exports